// extracted by mini-css-extract-plugin
export var menuItem = "H_v0 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "H_v1 d_Z d_bz d_bP";
export var menuMainLink = "H_v2 d_f0 d_dB";
export var menuLink = "H_v3 d_f0 d_dB";
export var icon = "H_p9 d_bC d_bP";
export var divider = "H_v4 d_bC d_bP";
export var sublinks = "H_v5";
export var link = "H_mC";
export var Link = "H_rJ q_rJ q_qW q_rf";